// extracted by mini-css-extract-plugin
module.exports = {"container":"ContractSign_style_container__i4IGD","contract":"ContractSign_style_contract__1iOUd"};